document.addEventListener('DOMContentLoaded', function () {
  // mobile menu
  var hamburgerBtn = document.getElementById('hamburgerBtn');
  var mainNav = document.getElementById('mainNav');
  if (hamburgerBtn && mainNav) {
    hamburgerBtn.addEventListener('click', function () {
      var isOpen = mainNav.classList.toggle('nav-open');
      mainNav.style.display = isOpen ? 'flex' : '';
    });
  }

  // sticky header shadow
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 12);
    });
  }

  // accordions
  document.querySelectorAll('.accordion-item').forEach(function (item) {
    var head = item.querySelector('.accordion-head');
    var body = item.querySelector('.accordion-body');
    if (!head || !body) return;
    if (item.classList.contains('open')) {
      body.style.maxHeight = body.scrollHeight + 'px';
    }
    head.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      var parent = item.parentElement;
      parent.querySelectorAll('.accordion-item.open').forEach(function (sib) {
        if (sib !== item) {
          sib.classList.remove('open');
          var sibBody = sib.querySelector('.accordion-body');
          if (sibBody) sibBody.style.maxHeight = null;
        }
      });
      item.classList.toggle('open', !isOpen);
      body.style.maxHeight = !isOpen ? body.scrollHeight + 'px' : null;
    });
  });

  // quantity selectors (product page + featured product section)
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // variant swatches -> update hidden variant id select (basic, first-level support)
  document.querySelectorAll('[data-variant-swatches]').forEach(function (group) {
    var buttons = group.querySelectorAll('.swatch');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        var select = document.querySelector('[data-variant-select]');
        var optionValue = btn.getAttribute('data-value');
        if (select && optionValue) {
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].getAttribute('data-option1') === optionValue) {
              select.selectedIndex = i;
              select.dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      });
    });
  });

  // product gallery thumb click
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('[data-gallery-main] img');
      var newSrc = thumb.getAttribute('data-full');
      if (mainImg && newSrc) mainImg.src = newSrc;
    });
  });

  // scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
});
